import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import {faAngleDoubleLeft, faAngleDoubleRight, faChevronRight, faPlus} from "@fortawesome/free-solid-svg-icons";
import { Observable, of } from "rxjs";
import { CatalogApiService } from "src/app/api/catalog-api.service";
import { LensConfigMode, LensSectionMode, LensSide, LensType } from "src/app/model/configuration/configuration";
import { LanguagePickerService } from "src/app/utils/language-picker/language-picker.service";
import { NewOrderStoreService } from "../new-order-store-service.service";
import { CalculationComponent } from "./calculation/calculation.component";
import { NewOrderTrialLensWithOverRefractionService } from "./new-order-trial-lens-with-overrefraction.service";
import { NewParameterComponent } from "./new-parameter/new-parameter.component";
import { OverRefractionComponent } from "./over-refraction/over-refraction.component";
import { TrialLensComponent } from "./trial-lens/trial-lens.component";
import * as cloneDeep from 'lodash/cloneDeep';

@Component({
    selector: 'app-new-order-trial-lens-with-overrefraction',
    templateUrl: './new-order-trial-lens-with-overrefraction.component.html',
    styleUrls: ['./new-order-trial-lens-with-overrefraction.component.scss']
})
export class NewOrderTrialLensWithOverrefractionComponent implements OnInit {
    originalMaterial: string[];

    LensSide = LensSide;
    panelOpenState = false;

    isRightSideEnable: boolean = true;
    isLeftSideEnable: boolean = true;
    isRightSideEnable$: Observable<boolean>;
    isLeftSideEnable$: Observable<boolean>;
    dataResponseRight: Object;
    dataResponseLeft: Object;

    previousRight: boolean = true;
    previousLeft: boolean = true;

    plusIcon = faPlus;
    arrowRight = faAngleDoubleRight;
    arrowLeft = faAngleDoubleLeft;

    @Output() copyEmit = new EventEmitter<LensSide>();
    @Output() switchEmit = new EventEmitter<LensSide>();
    @Output() rotateEmit = new EventEmitter<boolean>();

    @ViewChild('trialLensRight') trialLensRight: TrialLensComponent;
    @ViewChild('trialLensLeft') trialLensLeft: TrialLensComponent;
    @ViewChild('overRefractionRight') overRefractionRight: OverRefractionComponent;
    @ViewChild('overRefractionLeft') overRefractionLeft: OverRefractionComponent;
    @ViewChild('newParameterRight') newParameterRight: NewParameterComponent;
    @ViewChild('newParameterLeft') newParameterLeft: NewParameterComponent;
    @ViewChild('calculationRight') calculationRight: CalculationComponent;
    @ViewChild('calculationLeft') calculationLeft: CalculationComponent;

    @ViewChild('plusCrossTrialLensRight') plusCrossTrialLensRight;
    @ViewChild('plusCrossTrialLensLeft') plusCrossTrialLensLeft;

    constructor(private newOrderStoreService: NewOrderStoreService,
                private catalogApiService: CatalogApiService,
                private newOrderTrialLensWithOverRefractionService: NewOrderTrialLensWithOverRefractionService,
                private languagePickerService: LanguagePickerService) {}

    ngOnInit(): void {
        this.catalogApiService.searchMaterials({lensType: LensType.HARD}).subscribe(data => {
            this.originalMaterial = data.map(material => material.name);
            this.originalMaterial.sort(this.sortFilterNames);
            this.originalMaterial.unshift(NONE);
        });

        this.isRightSideEnable = this.newOrderStoreService.getIsRightSideEnable();
        this.newOrderStoreService.isRightSideEnable$.subscribe(data => {
            this.isRightSideEnable = data;
            if(this.isRightSideEnable) {
                this.plusCrossTrialLensRight.nativeElement.style.transform = 'rotate(45deg)';
            } else {
                this.discardRight();
                this.plusCrossTrialLensRight.nativeElement.style.transform = 'rotate(-1deg)';
            }
        });

        this.isLeftSideEnable = this.newOrderStoreService.getIsLeftSideEnable();
        this.newOrderStoreService.isLeftSideEnable$.subscribe(data => {
            this.isLeftSideEnable = data;
            if(this.isLeftSideEnable) {
                this.plusCrossTrialLensLeft.nativeElement.style.transform = 'rotate(45deg)';
            } else {
                this.discardLeft();
                this.plusCrossTrialLensLeft.nativeElement.style.transform = 'rotate(-1deg)';
            }
        });
    }

    togglePlusTrialLensRightSide() {
        this.newOrderStoreService.toggleIsRightSideEnable();
        this.newOrderStoreService.toggleLensConfigMode();
        if(this.isRightSideEnable) {
            this.plusCrossTrialLensRight.nativeElement.style.transform = 'rotate(45deg)';
        } else {
            this.plusCrossTrialLensRight.nativeElement.style.transform = 'rotate(-1deg)';
        }
    }

    togglePlusTrialLensLeftSide() {
        this.newOrderStoreService.toggleIsLeftSideEnable();
        this.newOrderStoreService.toggleLensConfigMode();
        if(this.isLeftSideEnable) {
            this.plusCrossTrialLensLeft.nativeElement.style.transform = 'rotate(45deg)';
        } else {
            this.plusCrossTrialLensLeft.nativeElement.style.transform = 'rotate(-1deg)';
        }
    }


    copy(sideFrom: LensSide) {
        this.copyEmit.emit(sideFrom);
    }

    switch(sideFrom: LensSide) {
        this.switchEmit.emit(sideFrom);

        this.newOrderStoreService.toggleIsRightSideEnable(true);
        this.newOrderStoreService.toggleIsLeftSideEnable(true);

        if(sideFrom === LensSide.RIGHT) {
            this.plusCrossTrialLensRight.nativeElement.style.transform = 'rotate(-1deg)';
            this.plusCrossTrialLensLeft.nativeElement.style.transform = 'rotate(45deg)';
        }
        else if(sideFrom === LensSide.LEFT) {
            this.plusCrossTrialLensLeft.nativeElement.style.transform = 'rotate(-1deg)';
            this.plusCrossTrialLensRight.nativeElement.style.transform = 'rotate(45deg)';
        }
    }

    rotateLens() {
        let isDual: boolean = this.isRightSideEnable && this.isLeftSideEnable;
        this.rotateEmit.emit(isDual);
    }

    private sortFilterNames(firstItem, secondItem) {
        if (firstItem < secondItem) {
            return -1;
        } else if (firstItem > secondItem) {
            return 1;
        }
        return 0;
    }

    calculate() {
        if(this.isRightSideEnable) {
            this.trialLensRight.checkRequiredFields();
            this.overRefractionRight.checkRequiredFields();
            this.newParameterRight.checkRequiredFields();
        }

        if(this.isLeftSideEnable) {
            this.trialLensLeft.checkRequiredFields();
            this.overRefractionLeft.checkRequiredFields();
            this.newParameterLeft.checkRequiredFields();
        }

        if(this.newOrderStoreService.getLensConfigMode() === LensConfigMode.SINGLE) {
            if(this.isRightSideEnable && this.trialLensRight.form.status === "VALID" && this.overRefractionRight.form.status === "VALID" && this.newParameterRight.form.status === "VALID") {
                this.dataResponseRight = undefined;
                this.newOrderTrialLensWithOverRefractionService.buildCalculationRequest([this.trialLensRight.form, this.overRefractionRight.form, this.newParameterRight.form, this.newOrderStoreService.getCopyTrialLensRight()])
                  .then(data => this.createData(data));
            } else if(this.isLeftSideEnable && this.trialLensLeft.form.status === "VALID" && this.overRefractionLeft.form.status === "VALID" && this.newParameterLeft.form.status === "VALID") {
                this.dataResponseLeft = undefined;
                this.newOrderTrialLensWithOverRefractionService.buildCalculationRequest([this.trialLensLeft.form, this.overRefractionLeft.form, this.newParameterLeft.form, this.newOrderStoreService.getCopyTrialLensLeft()])
                    .then(data => this.createData(data, true));
            }
        } else if(this.trialLensRight.form.status === "VALID" && this.overRefractionRight.form.status === "VALID" && this.newParameterRight.form.status === "VALID" &&
                  this.trialLensLeft.form.status === "VALID" && this.overRefractionLeft.form.status === "VALID" && this.newParameterLeft.form.status === "VALID"){
                this.dataResponseRight = undefined;
                this.dataResponseLeft = undefined;
                this.newOrderTrialLensWithOverRefractionService.buildCalculationRequest([this.trialLensRight.form, this.overRefractionRight.form, this.newParameterRight.form, this.newOrderStoreService.getCopyTrialLensRight()],
                                                                  [this.trialLensLeft.form, this.overRefractionLeft.form, this.newParameterLeft.form, this.newOrderStoreService.getCopyTrialLensLeft()]).then(data => this.createData(data));
        }
    }

    discard() {
        if(this.isRightSideEnable) {
            this.discardRight();
        }
        if(this.isLeftSideEnable) {
            this.discardLeft();
        }
    }

    discardRight() {
        this.dataResponseRight = undefined;

        this.trialLensRight.form.reset();
        this.overRefractionRight.form.reset();
        this.newParameterRight.form.reset();

        this.trialLensRight.selectedBackSide = undefined;
        this.overRefractionRight.clearAll();
    }

    discardLeft() {
        this.dataResponseLeft = undefined;

        this.trialLensLeft.form.reset();
        this.overRefractionLeft.form.reset();
        this.newParameterLeft.form.reset();

        this.trialLensLeft.selectedBackSide = undefined;
        this.overRefractionLeft.clearAll();
    }

    recalculate() {
        this.calculate();
    }

    selectLens() {
        document.querySelector('#final-lens').scrollIntoView();
        this.newOrderStoreService.changeLensSectionMode(LensSectionMode.FINAL_LENS);

        if(this.isRightSideEnable) {
            let obj = ({copyTrialLens: this.trialLensRight.copyTrialLens,
                trialLensSection: this.trialLensRight,
                overRefractionSection: this.overRefractionRight,
                newParameterSection: this.newParameterRight,
                calculationSection: this.calculationRight});

            this.newOrderStoreService.setTrialLensAllRight({trialLens: cloneDeep(obj)});
        }
        if(this.isLeftSideEnable) {
            let obj = ({copyTrialLens: this.trialLensLeft.copyTrialLens,
                trialLensSection: this.trialLensLeft,
                overRefractionSection: this.overRefractionLeft,
                newParameterSection: this.newParameterLeft,
                calculationSection: this.calculationLeft});

            this.newOrderStoreService.setTrialLensAllLeft({trialLens: cloneDeep(obj)});
        }

        this.discard();
    }

    private createData(data, isLeft = false) {
        if(isLeft) {
          (data[0]) ? this.dataResponseLeft = data[0] : this.dataResponseLeft = undefined;
        } else {
          (data[0]) ? this.dataResponseRight = data[0] : this.dataResponseRight = undefined;
          (data[1]) ? this.dataResponseLeft = data[1] : this.dataResponseLeft = undefined;
        }
    }


    isEnglish(): boolean {
        return this.languagePickerService.getLanguageCode() === 'en';
    }
}

export const NONE = 'NONE';
